import React from "react";

const Resume = ({ portfolio, data }) => {
  if (data) {
    var languages = "";
    data.languages.forEach((element) => {
      languages += element + ", ";
    });
    languages = languages.slice(0, -2);

    var skills = "";
    data.skills.forEach((element) => {
      skills += element + ", ";
    });
    skills = skills.slice(0, -2);

    var clubs = "";
    data.clubs.forEach((element) => {
      clubs += element + ", ";
    });
    clubs = clubs.slice(0, -2);

    var accomplishments = data.accomplishments.map(function (element) {
      return (
        <div key={element.title}>
          <b>{element.title}</b>
          {element.description.map((bullet) => {
            return <li>{bullet}</li>;
          })}
        </div>
      );
    });

    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3>{education.school}</h3>
          <p className="info">
            {education.degree} <span>&bull;</span>
            <em className="date">{education.graduated}</em>
          </p>
          {education.description.map((bullet) => {
            return <li>{bullet}</li>;
          })}
        </div>
      );
    });
    var work = data.work.map(function (work) {
      return (
        <div key={work.company}>
          <h3>{work.company}</h3>
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          {work.description.map((bullet) => {
            return <li>{bullet}</li>;
          })}
        </div>
      );
    });

    var projects = portfolio.projects.map(function (projects) {
      return (
        <div key={projects.title}>
          <h3>{projects.title}</h3>

          <p className="info">
            {projects.framework} <span>&bull;</span>
            <em className="date">{projects.date}</em>
          </p>
          {projects.description.map((bullet) => {
            return <li>{bullet}</li>;
          })}
        </div>
      );
    });
  }

  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <span>Education</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">{education}</div>
          </div>
        </div>
      </div>

      <div className="row work">
        <div className="three columns header-col">
          <h1>
            <span>Work Experience</span>
          </h1>
        </div>

        <div className="nine columns main-col">{work}</div>
      </div>

      <div className="row projects">
        <div className="three columns header-col">
          <h1>
            <span>Personal Projects</span>
          </h1>

          <p>Check out works below</p>
        </div>

        <div className="nine columns main-col">{projects}</div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
          <p>Most proficient first</p>
        </div>

        <div className="nine columns main-col">
          <ul className="languages">
            <b>Languages: </b>
            {languages}
          </ul>
          <ul className="skills">
            <b>Skills: </b>
            {skills}
          </ul>
        </div>
      </div>

      <div className="row other">
        <div className="three columns header-col">
          <h1>
            <span>Other</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <ul className="clubs">
            <b>Clubs: </b>
            {clubs}
          </ul>
          {accomplishments}
        </div>
      </div>
    </section>
  );
};

export default Resume;
